import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import IdleTimer from 'react-idle-timer'

import Interceptor from "./interceptor";

import "./App.css";
import {
  getAuthorizedUser,
  getUserData,
  logoutUser,
} from "./actions/signIn.actions";
import {
  successAlertHandler,
  failureAlertHandler,
} from "./actions/alert.actions";

const loading = () => <div class="animated fadeIn pt-3 text-center"></div>;

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

class App extends Component {
  constructor(props) {
    super(props);
    this.authenticate = this.authenticate.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  componentDidMount() {
    const { getUserData } = this.props;
    getUserData();
    this.handleUnathError = this.handleUnathError.bind(this);
    Interceptor.interceptHandler(Interceptor, this.handleUnathError);
    this.authenticate();
  }

  async handleUnathError(resp) {
    const { logoutUser, failureAlertHandler } = this.props;
    await logoutUser();
    failureAlertHandler("You are not Authorized!");
  }

  authenticate() {
    const { getAuthorizedUser, getUserData, history } = this.props;
    const userId = this.props.location.pathname.split("/")[2];
    const sessionId = this.props.location.pathname.split("/")[4];
    if (userId && sessionId) {
      getAuthorizedUser(userId, sessionId)
        .then(() => {
          history.push(`/reports/${userId}`);
        })
        .catch(() => {
          history.push("/");
        });
    } else {
      getUserData();
    }
  }

  handleOnIdle (event) {
    console.log('user is idle', event)
    console.log('last active', this.idleTimer.getLastActiveTime())
  }

  render() {
    return (
      <React.Suspense fallback={loading()}>
        <div>
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            timeout={10000}
            onIdle={this.handleOnIdle}
            debounce={250}
          />
          <Route
            path="/"
            name="Home"
            render={(props) => <DefaultLayout {...props} />}
          />
        </div>
      </React.Suspense>
    );
  }
}

const mapStateToProps = (state) => { };

const actions = {
  getUserData,
  getAuthorizedUser,
  logoutUser,
  successAlertHandler,
  failureAlertHandler,
};

export default withRouter(connect(mapStateToProps, actions)(App));
